import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

// ✅ FIX IMPORTANTE
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
  Filler
);

const defaultOptions = {
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
  },
  elements: {
    bar: {
      borderRadius: 8,
      borderSkipped: false,
    },
  },
  scales: {
    x: {
      grid: { display: false, drawBorder: false },
    },
    y: {
      grid: { display: false, drawBorder: false },
    },
  },
};

const BarChart = ({ chartData, options = {} }) => {
  const mergedOptions = { ...defaultOptions, ...options };

  return (
    <Bar
      key={JSON.stringify(chartData)} // ✅ FIX canvas reuse
      data={chartData}
      options={mergedOptions}
    />
  );
};

export default BarChart;